module.exports = {"TXTWCL_OopsX_No_Games_Found":{"id":"TXTWCL_OopsX_No_Games_Found","defaultMessage":"申し訳ありません。ゲームは見つかりませんでした"}}